/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
 ChangeEvent,
 useEffect,
 useState,
} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {
 getApiCall,
 postApiCall,
} from 'utils/api/httpService'
// import {AuthContext} from '@context/AuthProvider'
import {setGenericFormData} from '../../redux/reducer/genericFormReducer'
import {
 Select2DropdownField,
 TextField,
 RadioButtonField,
 DatePickerField,
 FileField,
 TextareaField,
} from '../index'
import moment from 'moment'
import {ToggleButtonField} from './form/ToggleButtonField'
import {
 fileUploadHandler,
 handleFileUpload,
 handleFileChange,
} from 'utils/helpers/fileUpload'
import {
 formatDateForDB,
 getFileName,
 getFileType,
 getFileTypeFromFileName,
 isValidRegex,
} from 'utils/helper'
import {toast} from 'react-toastify'
import {
 IFileObject,
 IFormField,
 PreSignedURL,
} from 'models/Common'
const GenericFormBuilder = (props: any) => {
 const {t} = useTranslation()
 const dispatch = useDispatch()
 //  const {userData}: any = useContext(AuthContext)
 //  const genericFormStore: any = useSelector(
 //   (state: any) => state?.genericFormReducer
 //  )
 const [formKeyValueMapping, setFormKeyValueMapping] =
  useState<any | null>(null)
 const [dropdownList, setDropdownList] = useState<
  any | null
 >({})
 const [formConfig, setFormConfig] = useState<any | null>(
  null
 )

 const [dropdownDataLoaded, setDropdownDataLoaded] =
  useState(false)

 const countryList = [
  {
   name: '+91',
   alternate_name: 'India',
   value: 'ind',
  },
  {
   name: '+1',
   alternate_name: 'USA',
   value: 'us',
  },
 ]

 const fetchData = async (
  childField: any,
  fieldId: any,
  value: any
 ) => {
  const dataSource = childField.fieldMetadata.dataSource
  const apiUrl = dataSource.apiUrl
  const requestType = dataSource.requestType
  const params: any = {}
  let checkForNull = false
  dataSource?.params?.map((parm: any) => {
   params[parm.paramId] = ''
   if (parm?.fieldId) {
    if (parm?.fieldId === fieldId) {
     params[parm.paramId] = value
    } else {
     //  const fieldObj = formKeyValueMapping[parm?.fieldId]
     params[parm.paramId] = props.watch(parm?.fieldId)
    }
   }
   //   else if (parm?.isConfig) {
   //   params[parm.paramId] = userData?.[parm?.configId]
   //  }
   else {
    params[parm.paramId] = parm.value
   }
   if (
    (Array.isArray(params[parm.paramId]) &&
     params[parm.paramId].length == 0) ||
    params[parm.paramId] === ''
   ) {
    checkForNull = true
   }
  })
  let res: any = []
  if (!checkForNull) {
   props.setLoader(true)
   // apiUrl = apiUrl.replace('/sps/', '')
   if (requestType === 'POST') {
    res = await postApiCall(apiUrl, {
     ...params,
    })
   } else {
    res = await getApiCall(apiUrl, {
     ...params,
    })
   }
  }
  props.setLoader(false)

  return [
   ...(dataSource?.responseKey
    ? res?.[dataSource.responseKey] || []
    : res || []),
   ...(childField?.custom_data || []),
  ]
 }

 function getFileUrl(fieldName: string) {
  console.log('props', props.uploadedFileData)
  console.log('props', props.uploadedFileData?.[fieldName])
 }

 function applyFilter(data: any) {
  props.setFormData({...data})
 }

 const setFormFields = () => {
  const fieldList = []
  let parentId = ''
  // unregister previous form fields
  if (
   props?.unregister &&
   formConfig?.fieldList?.length > 0
  ) {
   for (const field of formConfig.fieldList) {
    if (!props.excludedFields.includes(field.fieldId)) {
     props.unregister(field.fieldId) // Unregister fields not in the exception list
    }
   }
  }
  const uploadedFileData = {...props.uploadedFileData}
  if (props.itemConfigList?.length > 0) {
   for (const val of props.itemConfigList) {
    if (
     props?.itemIdentifier
      ? val.item_identifier === props.itemIdentifier
      : val.id === props.parentId
    ) {
     parentId = val.item_identifier
     for (const field of val.fields) {
      if (
       field.label_key?.match('^[^.]*$') &&
       !props.excludedFields.includes(field.label_key) &&
       (props?.includedFields
        ? props.includedFields.includes(field.label_key)
        : true)
      ) {
       const params: any = []
       let onLoadApiCall = true
       if (field?.query_params) {
        field?.query_params.map((paramName: any) => {
         if (onLoadApiCall && !props.getValues(paramName)) {
          onLoadApiCall = false
         }
         params.push({
          isConfig: false,
          fieldId: paramName,
          paramId: paramName,
          value: false,
         })
        })
       }
       const formValue = props.getValues(field.label_key)
       const hasFormValue =
        typeof formValue === 'boolean' ||
        (formValue !== undefined &&
         formValue !== null &&
         formValue !== '')
       let value: any = hasFormValue
        ? formValue
        : field?.value ?? ''
       let length = 1
       if (value) {
        if (field.field_type == 'DATE_FIELD') {
         value = new Date(field.value)
        } else if (Array.isArray(value)) {
         if (value.length === 1) {
          if (!value[0]) {
           value = ''
          }
         }
         length = value.length + 1
        } else {
         value?.toString()
        }
       }
       const fieldConfig = {
        fieldId: field.label_key,
        colSpan: field?.colSpan,
        isDisabled: field?.is_disabled ? true : false,
        isMultiple: field?.is_multiple ? true : false,
        length,
        caption: field?.caption ?? '',
        label: field.label,
        custom_data: field?.custom_data,
        fieldRegex:
         field.regex && isValidRegex(field.regex)
          ? field.regex
          : '',
        fieldRegexError: field.regex_error,
        description:
         field?.description ?? field?.descrie2ewption,
        value,
        presignedUrl: field?.presigned_url,
        s3FolderName: field?.s3_folder_name,
        fieldMetadata: {
         dataSource: {
          apiUrl: field?.api_url,
          labelKey:
           field?.value_key && field?.label_key
            ? field?.label_key
            : 'name',
          valueKey: field?.value_key ?? 'id',
          params,
          onLoadCall:
           !field?.query_params ||
           field?.query_params?.length === 0 ||
           field?.value ||
           (onLoadApiCall &&
            field?.query_params?.length >= 0)
            ? true
            : false,
          dependentFieldId: field?.child_dependent_fields,
          requestType: 'GET',
          source: field?.api_url ? 'api' : 'config',
          options: field?.options,
         },
         placeHolder: field.placeholder,
         inputType: field.field_type,
         isMandatory: field.is_mandatory,
         labelName: field.label,
         sequence: field.position,
        },
       }

       if (
        [
         'FILE_FIELD',
         'IMAGE_FIELD',
         'VIDEO_FIELD',
        ].includes(field.field_type)
       ) {
        if (fieldConfig.isMultiple) {
         const fileObj: string[] = []
         Array.from(
          {length: fieldConfig.length},
          (_, index) => {
           const fileValues = fieldConfig?.value?.[index]
           const keyName = `${fieldConfig.fieldId}.${index}`
           if (fileValues) {
            fileObj.push(fileValues)
            if (!uploadedFileData?.[keyName]) {
             uploadedFileData[keyName] = {
              filePath: fileValues,
              fileName: fileValues,
              fileType: getFileTypeFromFileName(fileValues),
              signedUrl: fieldConfig?.presignedUrl?.[index],
             }
            }
           }
          }
         )
         props.setValue(fieldConfig.fieldId, fileObj)
        } else {
         const fileValues = fieldConfig.value ?? ''
         const keyName = `${fieldConfig.fieldId}`
         props.setValue(keyName, fileValues)
         if (fileValues) {
          if (!uploadedFileData?.[keyName]) {
           uploadedFileData[keyName] = {
            filePath: fileValues,
            fileName: fileValues,
            fileType: getFileTypeFromFileName(fileValues),
            signedUrl: fieldConfig?.presignedUrl,
           }
          }
         }
        }
       }
       if (field.field_type !== 'BUTTON_FIELD') {
        if (
         ![
          'FILE_FIELD',
          'IMAGE_FIELD',
          'VIDEO_FIELD',
         ].includes(field.field_type)
        ) {
         props.setValue(
          fieldConfig.fieldId,
          fieldConfig.value
         )
        }
        fieldList.push(fieldConfig)
       }
      }
     }
    }
   }
  }
  if (props?.setUploadedFileData) {
   props.setUploadedFileData((prevState: IFormField) => ({
    ...prevState,
    ...uploadedFileData,
   }))
  }
  setFormConfig({
   parentId,
   fieldList,
  })
  console.log('fieldList', fieldList)
 }

 const createForm = async () => {
  // const data: any = genericFormStore?.data
  const dropdownData = {...dropdownList}
  const fieldKeyValueMapping = {...formKeyValueMapping}
  for (const field of formConfig?.fieldList) {
   const ddKey = formConfig.parentId + '_' + field.fieldId
   fieldKeyValueMapping[field.fieldId] = field
   const datasource: any = field.fieldMetadata?.dataSource
   if (datasource) {
    if (
     datasource?.onLoadCall &&
     datasource.source === 'api'
    ) {
     //  if (genericFormStore?.data?.[ddKey]?.length > 0) {
     //   dropdownData[ddKey] = genericFormStore.data[ddKey]
     //  } else {
     const res: any = await fetchData(
      field,
      field.fieldId,
      ''
     )
     if (res && res.length > 0) {
      //  const reduxData: any = {}
      //  reduxData[ddKey] = res
      //  dispatch(setGenericFormData({...reduxData}))
      dropdownData[ddKey] = res
     }
    } else {
     if (datasource?.options?.length > 0) {
      // if (genericFormStore?.data?.[ddKey]?.length > 0) {
      //  dropdownData[ddKey] = genericFormStore.data[ddKey]
      // } else {
      const options = datasource.options
      if (typeof options[0] !== 'object') {
       const optionArr = []
       for (const optionVal of options) {
        optionArr.push({
         id: optionVal,
         name: optionVal,
        })
       }
       dropdownData[ddKey] = optionArr
      } else {
       dropdownData[ddKey] = options
      }
      //  const reduxData: any = {}
      //  reduxData[ddKey] = dropdownData[ddKey]
      //  dispatch(setGenericFormData({...reduxData}))
     }
    }
   }
  }
  setDropdownList(dropdownData)
  setFormKeyValueMapping(fieldKeyValueMapping)
 }

 useEffect(() => {
  if (formConfig) void createForm()
 }, [formConfig])

 useEffect(() => {
  for (const key in dropdownList) {
   const fieldId = key.replace(
    `${formConfig.parentId}_`,
    ''
   )
   const field = formKeyValueMapping?.[fieldId]
   if (field) {
    const valueKey =
     field.fieldMetadata?.dataSource?.valueKey
    if (dropdownList[key]?.length > 0) {
     const ddValue = dropdownList[key][0]?.[valueKey]
     const existingValue =
      props.getValues(fieldId) ?? field?.value
     if (ddValue && existingValue) {
      const fieldDataType = typeof ddValue
      const value =
       fieldDataType === 'string'
        ? existingValue.toString()
        : fieldDataType === 'number'
        ? Number(existingValue)
        : existingValue

      props.setValue(fieldId, value)
     }
    }
   }
  }
  setDropdownDataLoaded(true)
 }, [formKeyValueMapping])

 useEffect(() => {
  if (props.itemConfigList) void setFormFields()
 }, [])

 function getDefaultValue(inputType: any) {
  let value: any = ''
  switch (inputType) {
   case 'MULTI_SELECT_SELECT_FIELD':
   case 'CHECK_BOX':
   case 'MULTISELECT_FIELD':
   case 'MULTISELECT_OPTION_FIELD':
    value = []
    break
   default:
    value = ''
  }
  return value
 }

 const handleChange = async (field: any) => {
  const datasource = field.fieldMetadata?.dataSource
  if (datasource?.dependentFieldId) {
   const ddData = {...dropdownList}

   const clearDependentFieldData = (fieldId: any) => {
    const ddKey = formConfig.parentId + '_' + fieldId
    const field = formKeyValueMapping[fieldId]
    const datasource = field.fieldMetadata?.dataSource
    props.setValue(
     fieldId,
     getDefaultValue(field?.fieldMetadata?.inputType)
    )
    ddData[ddKey] = getDefaultValue(
     field?.fieldMetadata?.inputType
    )
    if (datasource?.dependentFieldId) {
     clearDependentFieldData(
      datasource?.dependentFieldId?.[0]
     )
    }
   }

   clearDependentFieldData(datasource.dependentFieldId?.[0])
   const dependentField =
    formKeyValueMapping[datasource.dependentFieldId?.[0]]
   const ddKey =
    formConfig.parentId + '_' + dependentField.fieldId

   const valueArr = dependentField.fieldMetadata?.dataSource
    ?.isMultiApiCall
    ? props.watch(field.fieldId)
    : [props.watch(field.fieldId)]

   const ddArr: any = []
   for (const value of valueArr) {
    const res: any = await fetchData(
     dependentField,
     field.fieldId,
     value
    )
    Array.prototype.push.apply(ddArr, res)
   }
   ddData[ddKey] = ddArr
   setDropdownList({...ddData})
  }
 }

 const handleFileChangeEvent = async (
  e: ChangeEvent<HTMLInputElement>,
  isMultiple: boolean,
  isUpdate: boolean,
  s3_folder_name?: string
 ) => {
  e.preventDefault()
  const fieldArr = e.target.name.split('.')
  const parentFieldId = fieldArr?.[0]
  const res: PreSignedURL | null = await handleFileChange(
   e,
   props.uploadedFileData,
   props.setLoader,
   props.setUploadedFileData,
   parentFieldId,
   s3_folder_name
  )
  if (res) {
   props.setValue(e.target.name, res.filepath)
   if (isMultiple && !isUpdate) {
    if (parentFieldId) {
     const fieldKeyValueMapping = {...formKeyValueMapping}
     fieldKeyValueMapping[parentFieldId].length =
      fieldKeyValueMapping[parentFieldId].length + 1
     setFormKeyValueMapping({...fieldKeyValueMapping})
    }
   }
  }
 }

 const handleFileDropEvent = async (
  file: File,
  fieldId: string,
  isMultiple: boolean,
  isUpdate: boolean,
  s3_folder_name?: string
 ) => {
  const fieldArr = fieldId.split('.')
  const parentFieldId = fieldArr?.[0]
  const res = await handleFileUpload(
   file,
   fieldId,
   props.uploadedFileData,
   props.setLoader,
   props.setUploadedFileData,
   s3_folder_name
  )
  if (res) {
   props.setValue(fieldId, res.filepath)
   if (isMultiple && !isUpdate && parentFieldId) {
    const fieldKeyValueMapping = {...formKeyValueMapping}
    fieldKeyValueMapping[parentFieldId].length =
     fieldKeyValueMapping[parentFieldId].length + 1
    setFormKeyValueMapping({...fieldKeyValueMapping})
   }
  }
 }

 const populateField = (field: any) => {
  const labelName = field.fieldMetadata?.labelName
  const fieldId = field.fieldId
  const inputType = field.fieldMetadata.inputType
  const ddKey = formConfig.parentId + '_' + field.fieldId
  const placeholder =
   field.fieldMetadata?.placeHolder || labelName
  switch (field.fieldMetadata.inputType) {
   case 'TEXT_FIELD': {
    return (
     <TextField
      type='text'
      disabled={props.isDisabled || field?.isDisabled}
      label={labelName}
      required={field.fieldMetadata?.isMandatory}
      helperText={field.caption}
      helperTextClass='text-[#80868C] text-xs font-normal'
      className='relative !text-lg !font-medium !text-[#33393D]'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (
            v !== '' &&
            !v?.toString()?.match(field.fieldRegex)
           )
            return field?.fieldRegexError
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        // checkForDependentFields(field)
       },
      })}
      placeholder={placeholder}
      errors={props.errors}
     />
    )
   }
   case 'CURRENCY_FIELD': {
    return (
     <div className='form-field-wrapper relative flex items-stretch rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]'>
      <div className='bg-[#E6EBF0] rounded-l-lg py-3 px-4 flex items-center text-[#33393D] text-2xl font-medium'>
       <i className='fa fa-inr pr-0.5'></i>
      </div>
      <TextField
       type='text'
       disabled={props.isDisabled || field?.isDisabled}
       label={labelName}
       required={field.fieldMetadata?.isMandatory}
       helperText={field.caption}
       helperTextClass='text-[#80868C] text-xs font-normal'
       wrapperClassName={'max-w-full w-full'}
       inputWrapperClassName='rounded-r-lg !rounded-l-none border-none'
       className='relative !text-lg !font-medium !text-[#33393D]'
       id={`${fieldId}`}
       name={`${fieldId}`}
       register={props.register(`${fieldId}`, {
        ...((field.fieldRegex ||
         field.fieldMetadata?.isMandatory) && {
         validate: {
          ...(field.fieldRegex && {
           regex: (v: any) => {
            if (v !== '' && !v?.match(field.fieldRegex))
             return field?.fieldRegexError
           },
          }),
          ...(field.fieldMetadata?.isMandatory && {
           required: (v: any) => {
            if (v === '') return `Please Enter ${labelName}`
           },
          }),
         },
        }),
        onChange: (e: any) => {
         // checkForDependentFields(field)
        },
       })}
       placeholder={placeholder}
       errors={props.errors}
      />
     </div>
    )
   }
   case 'TEXTAREA_FIELD': {
    return (
     <TextareaField
      disabled={props.isDisabled || field?.isDisabled}
      rows={1}
      label={labelName}
      required={field.fieldMetadata?.isMandatory}
      helperText={field.caption}
      helperTextClass='text-[#80868C] text-xs font-normal'
      labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
      className='relative !text-lg !font-medium !text-[#33393D]'
      wrapperClassName='relative w-full col-span-2'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        // checkForDependentFields(field)
       },
      })}
      placeholder={placeholder}
      errors={props.errors}
     />
    )
   }
   case 'FILE_FIELD': {
    return (
     <FileField
      disabled={props.isDisabled || field?.isDisabled}
      hideUploadIcon={true}
      popupHeader={field?.label}
      label={field.isMultiple ? undefined : labelName}
      labelClassName='!text-[#171B1F] !text-base !font-bold !pb-0.5'
      className='font-normal'
      wrapperClassName={`w-full min-h-[96px] ${
       field.isMultiple && 'mr-2'
      }`}
      uploadType={field.fieldMetadata.inputType}
      required={field.fieldMetadata?.isMandatory}
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        void handleFileChangeEvent(
         e,
         field?.isMultiple,
         props.uploadedFileData?.[fieldId]?.signedUrl
          ? true
          : false,
         field?.s3FolderName
        )
       },
      })}
      placeholder={placeholder}
      errors={props.errors}
      signedPhoto={
       props.uploadedFileData?.[fieldId]?.signedUrl
      }
      fileType={props.uploadedFileData?.[fieldId]?.fileType}
      fileName={props.uploadedFileData?.[fieldId]?.fileName}
      onFileDrop={async (file: File) => {
       await handleFileDropEvent(
        file,
        fieldId,
        field?.isMultiple,
        props.uploadedFileData?.[fieldId]?.signedUrl
         ? true
         : false,
        field?.s3FolderName
       )
      }}
      uploadHintText={
       field?.label
        ? `Click to upload ${field.label.toLowerCase()} or drag & drop`
        : undefined
      }
      validFileText={
       field?.description ||
       field?.caption ||
       t('common.supportedFileFormats')
      }
     />
    )
   }
   case 'IMAGE_FIELD':
   case 'VIDEO_FIELD': {
    return (
     <FileField
      disabled={props.isDisabled || field?.isDisabled}
      hideUploadIcon={true}
      popupHeader={field?.label}
      label={field.isMultiple ? undefined : labelName}
      wrapperClassName={`w-full min-h-[96px] ${
       field.isMultiple && 'mr-2'
      }`}
      labelClassName='!text-[#171B1F] !text-base !font-bold !pb-0.5'
      className='font-normal'
      uploadType={field.fieldMetadata.inputType}
      required={field.fieldMetadata?.isMandatory}
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        void handleFileChangeEvent(
         e,
         field?.isMultiple,
         props.uploadedFileData?.[fieldId]?.signedUrl
          ? true
          : false
        )
       },
      })}
      placeholder={placeholder}
      errors={props.errors}
      signedPhoto={
       props.uploadedFileData?.[fieldId]?.signedUrl
      }
      fileType={props.uploadedFileData?.[fieldId]?.fileType}
      fileName={props.uploadedFileData?.[fieldId]?.fileName}
      onFileDrop={async (file: File) => {
       await handleFileDropEvent(
        file,
        fieldId,
        field?.isMultiple,
        props.uploadedFileData?.[fieldId]?.signedUrl
         ? true
         : false
       )
      }}
      uploadHintText={
       field?.label
        ? `Click to upload ${field.label.toLowerCase()} or drag & drop`
        : undefined
      }
      validFileText={
       field?.description ||
       field?.caption ||
       t('common.supportedFileFormats')
      }
     />
    )
   }
   case 'SELECT_FIELD':
   case 'DROPDOWN':
   case 'MULTI_SELECT_SELECT_FIELD':
   case 'MULTISELECT_FIELD':
   case 'MULTI_SELECT_CROP_FIELD':
   case 'MULTISELECT_OPTION_FIELD':
   case 'SELECT_STATE_FIELD':
   case 'SELECT_DISTRICT_FIELD':
   case 'SELECT_SUB_DISTRICT_FIELD':
   case 'SELECT_FIRM_NAME_FIELD': {
    return (
     <Select2DropdownField
      disabled={props.isDisabled || field?.isDisabled}
      label={field.label}
      required={field.fieldMetadata?.isMandatory}
      helperText={field.caption}
      helperTextClass='text-[#80868C] text-xs font-normal'
      isMultiselect={
       inputType == 'MULTI_SELECT_SELECT_FIELD' ||
       inputType == 'MULTISELECT_FIELD' ||
       inputType == 'MULTI_SELECT_CROP_FIELD' ||
       inputType == 'MULTISELECT_OPTION_FIELD'
        ? true
        : false
      }
      labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
      className={`${
       field.fieldMetadata?.isDisabled
        ? '!text-[#33393D]'
        : 'font-normal !text-[#33393D]'
      } boxed-select2 !font-medium  relative block text-lg border-0  !rounded-l-lg`}
      wrapperClassName='relative w-full'
      inputWrapperClassName='pl-4 py-2 px-4 '
      control={props.control}
      id={`${fieldId}`}
      name={`${fieldId}`}
      rules={{
       ...(field.fieldMetadata?.isMandatory && {
        validate: {
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (!v || (Array.isArray(v) && v.length === 0))
            return `Please Select ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        const valueKey =
         field.fieldMetadata?.dataSource?.valueKey

        const selectedOption = dropdownList[ddKey]?.find(
         (opt: any) =>
          String(opt[valueKey]) === String(e.target.value)
        )

        if (props.onOrganisationSelect) {
         props.onOrganisationSelect(
          field.fieldId,
          e.target.value,
          selectedOption
         )
        }

        void handleChange(field)
       },
      }}
      placeholder={placeholder}
      data={dropdownList[ddKey] || []}
      OptionValueKey={
       field.fieldMetadata?.dataSource?.valueKey
      }
      OptionLabelKey={
       field.fieldMetadata?.dataSource?.labelKey
      }
      customStyle={{
       transition: 'unset',
       boxShadow: 'unset',
       border: '0px',
       borderRadius: '0px',
       padding: '0px 0px 0px 0px',
       minHeight: 'auto',
      }}
      errors={props.errors}
     />
    )
   }
   case 'PHONE_NUMBER_FIELD': {
    return (
     <div className='relative w-full'>
      <Select2DropdownField
       inputWrapperClassName='!border-0 !text-[#33393D]'
       className='country-code-select image-selector relative m-0 block !text-[#33393D] text-lg w-[70px] border-0 font-medium !rounded-l-lg'
       wrapperClassName='absolute z-[1] left-[2px] top-[2px] flex items-center'
       required={false}
       disabled={true}
       isClearable={false}
       isSearchable={false}
       control={props.control}
       customStyle={{
        borderColor: '#E6EBF0',
        border: '0px',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
        padding: '0px 8px 0px 0px',
        height: '67px',
        backgroundColor: '#F5F8FA',
       }}
       data={countryList}
       value={'ind'}
       id={`country`}
       name={`country`}
       onChange={() => {
        // handleChangeLanguage(e.target.value)
       }}
       OptionValueKey='value'
       OptionLabelKey='name'
       placeholder={t('loginPage.country')}
      />
      <TextField
       type='text'
       maxLength={10}
       disabled={props.isDisabled || field?.isDisabled}
       label={labelName}
       required={field.fieldMetadata?.isMandatory}
       helperText={field.caption}
       helperTextClass='text-[#80868C] text-xs font-normal'
       labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
       className='font-normal !text-lg !font-medium !text-[#33393D]'
       wrapperClassName='relative w-full'
       inputWrapperClassName='pl-20'
       showIcon={true}
       errorIconClassName='top-[35%]'
       id={`${fieldId}`}
       name={`${fieldId}`}
       register={props.register(`${fieldId}`, {
        validate: {
         regex: (v: string) => {
          if (v !== '' && !v?.match('^[6-9][0-9]{9}$'))
           return `${t(
            'helperText.plsEnterValid'
           )} ${labelName}`
         },
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
        onChange: (e: any) => {
         // checkForDependentFields(field)
        },
       })}
       placeholder={placeholder}
       errors={props.errors}
      />
     </div>
    )
   }
   case 'RADIO_BTN':
   case 'CHOICE_FIELD':
   case 'CHECK_BOX': {
    return (
     <RadioButtonField
      disabled={props.isDisabled || field?.isDisabled}
      label={field.label}
      required={field.fieldMetadata?.isMandatory}
      helperText={field.caption}
      helperTextClass='text-[#80868C] text-xs font-normal'
      type={
       inputType == 'RADIO_BTN' ||
       inputType == 'CHOICE_FIELD'
        ? 'radio'
        : 'checkbox'
      }
      wrapperClassName={'w-full'}
      containerClass='form-field-wrapper py-0.5 relative bg-white'
      className='relative !text-lg !font-medium !text-[#33393D]'
      listWrapperClass='flex gap-2 flex-wrap'
      labelClassName='input-label relative pb-1 text-[#4E83E4] text-xs font-medium'
      listItemClassName='bg-[#F5F8FA] rounded-lg py-2 px-4 text-[#33393D] font-medium !m-0'
      listLabelClassName='text-[#33393D] text-lg font-medium'
      id={`${fieldId}`}
      name={`${fieldId}`}
      value={field.value}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        // checkForDependentFields(field)
       },
      })}
      placeholder={placeholder}
      data={dropdownList[ddKey] || []}
      OptionValueKey={
       field.fieldMetadata?.dataSource?.valueKey
      }
      OptionLabelKey={
       field.fieldMetadata?.dataSource?.labelKey
      }
      errors={props.errors}
     />
    )
   }

   case 'DATE_FIELD': {
    return (
     <DatePickerField
      disabled={props.isDisabled || field?.isDisabled}
      label={labelName}
      required={field.fieldMetadata?.isMandatory}
      helperText={field.caption}
      helperTextClass='text-[#80868C] text-xs font-normal'
      wrapperClassName={'w-full'}
      className='relative !text-lg !font-medium !text-[#33393D] !p-0'
      control={props.control}
      dateFormat='dd-MM-yyyy'
      id={`${fieldId}`}
      name={`${fieldId}`}
      rules={{
       onChange: (e: any) => {
        // handleChange(field)
       },
      }}
      maxDate={moment().toDate()}
      placeholder={placeholder}
      errors={props.errors}
     />
    )
   }
   case 'DATE_RANGE_PICKER': {
    return (
     <div className='w-full'>
      <div className='w-full flex '>
       <DatePickerField
        disabled={props.isDisabled || field?.isDisabled}
        label={''}
        required={field.fieldMetadata?.isMandatory}
        wrapperClassName={'w-full'}
        className='relative text-[16px] font-medium'
        control={props.control}
        dateFormat='dd-MM-yyyy'
        id={`${fieldId}`}
        name={`${fieldId}`}
        rules={{
         onChange: (e: any) => {
          // handleChange(field)
         },
        }}
        maxDate={
         inputType == 'DATE_RANGE_PICKER'
          ? props.watch(
             field.fieldMetadata?.toDateFieldId
            ) || moment().toDate()
          : moment().toDate()
        }
        placeholder={placeholder}
        errors={props.errors}
       />
      </div>
      {inputType == 'DATE_RANGE_PICKER' && (
       <div className='w-full mt-4 flex'>
        <div className='pb-4 text-[18px] font-medium text-[#2F2F2F] mr-2 w-[200px]'>
         Select {field.fieldMetadata?.toDateFieldLabel}
        </div>
        <DatePickerField
         label={''}
         required={field.fieldMetadata?.isMandatory}
         wrapperClassName={'max-w-[350px]'}
         className='relative text-[16px] font-medium'
         control={props.control}
         dateFormat='dd-MM-yyyy'
         id={`${field.fieldMetadata?.toDateFieldId}`}
         name={`${field.fieldMetadata?.toDateFieldId}`}
         rules={{
          onChange: (e: any) => {
           // handleChange(field)
          },
         }}
         minDate={
          inputType == 'DATE_RANGE_PICKER' &&
          props.watch(fieldId)
         }
         maxDate={moment().toDate()}
         placeholder={field.fieldMetadata?.toDateFieldLabel}
         errors={props.errors}
        />
       </div>
      )}
     </div>
    )
   }

   case 'TOGGLE_FIELD': {
    return (
     <ToggleButtonField
      disabled={props.isDisabled || field?.isDisabled}
      type='text'
      label={labelName}
      desc={field?.description}
      required={field.fieldMetadata?.isMandatory}
      labelClassName='!text-[#33393D] !text-lg !font-medium'
      descClassName='text-[#33393D] text-sm !font-medium'
      className='!w-10 !h-5 font-normal'
      btnClassName={`!h-3 !w-3`}
      wrapperClassName='relative w-full'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        // checkForDependentFields(field)
       },
      })}
      watch={props.watch}
      setValue={props.setValue}
      placeholder={placeholder}
      errors={props.errors}
     />
    )
   }
   case 'CONSENT_FIELD': {
    return (
     <ToggleButtonField
      disabled={props.isDisabled || field?.isDisabled}
      type='text'
      label={labelName}
      desc={field?.description}
      required={field.fieldMetadata?.isMandatory}
      moveBtnToEnd={true}
      labelPosition='start'
      iconPath={props?.toggleBtnIconList?.[fieldId]}
      labelClassName='!text-[#2F2F2F] !text-lg !font-medium'
      descClassName='!text-[#33393D] text-xs !font-medium'
      className='!w-10 !h-5 font-normal'
      btnClassName={`!h-3 !w-3`}
      wrapperClassName='relative w-full'
      id={`${fieldId}`}
      name={`${fieldId}`}
      register={props.register(`${fieldId}`, {
       ...((field.fieldRegex ||
        field.fieldMetadata?.isMandatory) && {
        validate: {
         ...(field.fieldRegex && {
          regex: (v: any) => {
           if (v !== '' && !v?.match(field.fieldRegex))
            return field?.regexErrorMessage
          },
         }),
         ...(field.fieldMetadata?.isMandatory && {
          required: (v: any) => {
           if (v === '') return `Please Enter ${labelName}`
          },
         }),
        },
       }),
       onChange: (e: any) => {
        // checkForDependentFields(field)
       },
      })}
      watch={props.watch}
      setValue={props.setValue}
      placeholder={placeholder}
      errors={props.errors}
     />
    )
   }
  }
 }

 return (
  <>
   {dropdownDataLoaded &&
    formConfig?.fieldList?.map((field: any, i: any) => {
     const isFileField = [
      'FILE_FIELD',
      'IMAGE_FIELD',
      'VIDEO_FIELD',
     ].includes(field.fieldMetadata.inputType)

     return (
      <div
       className={`${props?.className} ${
        isFileField
         ? 'col-span-full w-full'
         : field?.colSpan
         ? `col-span-${field.colSpan} w-full`
         : 'w-full'
       }`}
       key={i}
      >
       {[
        'FILE_FIELD',
        'IMAGE_FIELD',
        'VIDEO_FIELD',
       ].includes(field.fieldMetadata.inputType) &&
       field.isMultiple ? (
        <div className='relative w-full h-full mr-2 false form-field-wrapper py-2 px-4 relative rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]'>
         <div className='input-label padding-0 text-[#4E83E4] text-xs !font-medium relative pb-1 text-[#4E83E4] text-xs font-medium'>
          {field?.label}
          {field.fieldMetadata?.isMandatory && (
           <span className='required-field pl-[2px]'>
            *
           </span>
          )}
         </div>
         <div className='pb-1 flex flex-col gap-2 w-full'>
          {Array.from(
           {
            length: field.length,
           },
           (_, index) =>
            populateField({
             ...field,
             fieldId: `${field.fieldId}.${index}`,
             ...(index > 0 && {
              fieldMetadata: {
               isMandatory: false,
               ...field.fieldMetadata,
              },
             }),
            })
          )}
         </div>
        </div>
       ) : (
        populateField(field)
       )}
      </div>
     )
    })}
  </>
 )
}

export default GenericFormBuilder
